;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .directive('activityItem', activityItem)

  function activityItem () {
    return {
      restrict: 'E',
      scope: {
        activity: '='
      },
      templateUrl: '/core/directives/activity-item/activity-item-directive.html?$$REVISION$$',
      controller: 'ActivityItemController'
    }
  }
})()
